import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get, map, filter, sortBy, size } from "lodash";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import CreateContainer from "./CreateContainer";
import InfoSection from "../Common/InfoSection";

import { displayBoolean } from "../../utils/data";
import { getAttributeValue } from "../../utils/profile";

import { levels } from "../../constants/companies";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";

// Map
import { Map, Marker, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const styles = {
  title: {
    fontSize: "1.8em",
    color: colors.black87,
  },
};

const CompanyDetails = (props) => {
  const {
    classes,
    companyId,
    siteId,
    zoneId,
    deviceId,
    item,
    itemAttr,
    level,
    fetchItem,
    language,
  } = props;

  const [editMode, setEditMode] = React.useState(false);

  if (editMode) {
    return (
      <CreateContainer
        refresh={() => {
          setEditMode(false);
          fetchItem();
        }}
        level={level}
        item={item}
        companyId={companyId}
        siteId={siteId}
        zoneId={zoneId}
        deviceId={deviceId}
        cancel={() => setEditMode(false)}
        edition={true}
      />
    );
  }

  return (
    <>
      <Grid item>
        <Grid container alignItems="baseline">
          <Grid item className={classes.title} style={{ paddingRight: "12px" }}>
            {get(item, ["name"])}
          </Grid>
          <Grid item>
            <Grid item className="text-38" style={{ fontSize: "1.142em" }}>
              ({I18n.get(`companies_${level}`).toLowerCase()})
            </Grid>
          </Grid>
          <Grid item xs />
          <Grid item>
            <img
              src={images.editIconColored}
              alt="edit"
              style={{ cursor: "pointer" }}
              onClick={() => setEditMode(true)}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item style={{ margin: "20px 0px 20px -8px" }}>
        <Grid
          container
          wrap="nowrap"
          // style={{ overflow: "auto", maxHeight: "calc(100vh - 200px)" }}
        >
          <Grid item xs style={{ maxWidth: "600px" }}>
            <Grid container>
              <Grid item xs={6}>
                <Grid container direction="column">
                  <InfoSection
                    title2={I18n.get(`companies_${level}Type`)}
                    values={[get(item, [`${level}_type_name_${language}`])]}
                    style={{ width: "300px" }}
                  />
                  {level === levels.zone && (
                    <>
                      <InfoSection
                        title2={I18n.get("site_parentZone")}
                        values={[get(item, ["parent_zone_name"]) || "-"]}
                        style={{ width: "300px" }}
                      />
                      <InfoSection
                        title2={I18n.get("dashboard_entrance")}
                        values={[
                          displayBoolean(get(item, ["is_entrance"]) || false),
                        ]}
                        style={{ width: "300px" }}
                      />
                      <InfoSection
                        title2={I18n.get("dashboard_exit")}
                        values={[
                          displayBoolean(get(item, ["is_exit"]) || false),
                        ]}
                        style={{ width: "300px" }}
                      />
                    </>
                  )}
                  {size(
                    filter(itemAttr, (attr) =>
                      [20, 21, 22, 23, 24, 25, 26, 27].includes(attr.id)
                    )
                  ) > 0 && (
                    <Grid item style={{ padding: "8px", maxWidth: "100%" }}>
                      <Box className={"text-87 bold-500"}>
                        {I18n.get("companies_address")}
                      </Box>
                      {size(
                        filter(get(item, ["attributes"]), (attr) =>
                          getAttributeValue(item, attr.id)
                        )
                      ) === 0 && <span className="text-54">-</span>}
                      {map(
                        filter(itemAttr, (attr) =>
                          [20, 21, 22, 23, 24, 25, 26, 27].includes(attr.id)
                        ),
                        (attr, index) =>
                          getAttributeValue(item, attr.id) && (
                            <Box key={index} className="text-54">
                              {getAttributeValue(item, attr.id)}
                            </Box>
                          )
                      )}
                    </Grid>
                  )}
                  {map(
                    sortBy(
                      filter(
                        itemAttr,
                        (attr) =>
                          attr.active &&
                          attr.app_display_main_page &&
                          ![20, 21, 22, 23, 24, 25, 26, 27].includes(attr.id)
                      ),
                      (attr) => get(attr, ["app_display_seq_numb"])
                    ),
                    (attr) => (
                      <InfoSection
                        key={attr.id}
                        attribute={attr}
                        id={attr.id}
                        values={[getAttributeValue(item, attr.id)]}
                      />
                    )
                  )}
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container direction="column">
                  {map(
                    sortBy(
                      filter(
                        itemAttr,
                        (attr) => attr.active && !attr.app_display_main_page
                        // && ![28, 92].includes(attr.id)
                      ),
                      (attr) => get(attr, ["app_display_seq_numb"])
                    ),
                    (attr) => (
                      <InfoSection
                        key={attr.id}
                        attribute={attr}
                        id={attr.id}
                        values={[getAttributeValue(item, attr.id)]}
                      />
                    )
                  )}
                  {level === levels.zone && (
                    <>
                      <InfoSection
                        title2={I18n.get("site_siteImpactCount")}
                        values={[
                          displayBoolean(
                            get(item, ["is_impact_site_count"]) || false
                          ),
                        ]}
                        style={{ width: "300px" }}
                      />
                      <InfoSection
                        title="color"
                        color={
                          get(item, ["color", "rgb"]) ||
                          get(item, ["type", "color", "rgb"])
                        }
                        style={{ width: "300px" }}
                      />
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {level === levels.site &&
            getAttributeValue(item, 92) &&
            getAttributeValue(item, 28) && (
              <Grid item style={{ width: "400px" }}>
                <Grid container direction="column" wrap="nowrap">
                  {/* <Grid item>
             <Grid container wrap="nowrap">
               <Grid item xs={6}>
                 <InfoSection
                   attribute={get(
                     filter(itemAttr, (attr) => attr.id === 28),
                     [0]
                   )}
                   id={28}
                   values={[getAttributeValue(item, 28)]}
                 />
               </Grid>
               <Grid item xs={6}>
                 <InfoSection
                   attribute={get(
                     filter(itemAttr, (attr) => attr.id === 92),
                     [0]
                   )}
                   id={92}
                   values={[getAttributeValue(item, 92)]}
                 />
               </Grid>
             </Grid>
           </Grid> */}
                  <Grid item>
                    <Map
                      style={{ height: "300px", width: "100%", zIndex: 1 }}
                      zoom={15}
                      center={[
                        getAttributeValue(item, 28),
                        getAttributeValue(item, 92),
                      ]}
                    >
                      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                      <Marker
                        position={[
                          getAttributeValue(item, 28),
                          getAttributeValue(item, 92),
                        ]}
                      />
                    </Map>
                  </Grid>
                </Grid>
              </Grid>
            )}
        </Grid>
      </Grid>
    </>
  );
};

export default withStyles(styles)(CompanyDetails);
